import AutoAwesome from '@mui/icons-material/AutoAwesome';
import { ButtonProps } from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { t } from 'i18next';

import { SmallButton } from '~components/Order/ordersDispatchStyledComponents';

import useLlmPrompt from './useLlmPrompt';

interface CopyLlmPromptButtonProps extends Omit<ButtonProps, 'onClick'> {
  apiBaseUrl: string;
  companyId: string;
  companyName: string;
  onCopied?: () => void;
}

export default function CopyLlmPromptButton({
  apiBaseUrl,
  children,
  companyId,
  companyName,
  onCopied,
  ...buttonProps
}: CopyLlmPromptButtonProps) {
  const { copyPrompt } = useLlmPrompt({ apiBaseUrl, companyId, companyName });

  const handleClick = async () => {
    if (await copyPrompt()) {
      onCopied?.();
    }
  };

  // describeChild keeps the button's own label as its accessible name; without it
  // MUI promotes the whole tooltip paragraph to the button's aria-label.
  return (
    <Tooltip describeChild title={t('administration.api_clients.llm_prompt_tooltip')}>
      <SmallButton
        color="secondary"
        data-ui="page-settings-api-clients__management__copy-llm-prompt-button"
        onClick={handleClick}
        startIcon={<AutoAwesome />}
        variant="outlined"
        {...buttonProps}
      >
        {children ?? t('administration.api_clients.copy_llm_prompt_button')}
      </SmallButton>
    </Tooltip>
  );
}
